import React, { useState } from 'react';
import { TALocalDescription } from '../../types/TALocal';

export const wideImage = (
  desc: Partial<TALocalDescription> | undefined,
  thumbnail?: string | null
): string | null =>
  desc?.imageUrls?.find(url => !!url) || desc?.logoUrl || thumbnail || null;

const ICON_PATHS = {
  restaurant: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z',
  hotel: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z',
  bus: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z',
  store: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z',
};

export type CategoryIcon = keyof typeof ICON_PATHS;

export const categoryIcon = (category?: string | null): CategoryIcon => {
  const c = category?.toLowerCase().trim() ?? '';
  if (c.includes('food') || c.includes('restaurant') || c.includes('cafe')) return 'restaurant';
  if (c.includes('accommodation') || c.includes('hotel') || c.includes('motel')) return 'hotel';
  if (c.includes('transport') || c.includes('shuttle')) return 'bus';
  return 'store';
};

interface ListingImageProps {
  desc?: TALocalDescription;
  thumbnail?: string | null;
  alt: string;
  colorClass: string;
  className: string;
}

const ListingImage: React.FC<ListingImageProps> = ({ desc, thumbnail, alt, colorClass, className }) => {
  const url = wideImage(desc, thumbnail);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  if (url && url !== failedUrl) {
    return <img src={url} alt={alt} className={`${className} object-cover`} onError={() => setFailedUrl(url)} />;
  }

  return (
    <div className={`${className} flex items-center justify-center ${colorClass}`} role="img" aria-label={alt}>
      <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d={ICON_PATHS[categoryIcon(desc?.['Product Category'])]} />
      </svg>
    </div>
  );
};

export default ListingImage;
